import s from './state'
import * as a from './actions'
import * as m from './mutations'
import * as g from './getters'
// Premissas do escritório (spec-017). Slice autocontido em arquivo próprio,
// MESCLADO aqui para que as chaves fiquem planas no namespace do módulo
// (`feeFixo/premissas`), como as dos demais slices.
import * as premissas from './premissas'
// Role play falado (spec-018). Mesmo arranjo do slice de premissas: arquivo
// próprio, chaves planas no namespace `feeFixo`.
import * as roleplay from './roleplay'

export const state = () => ({
  ...s,
  ...premissas.state(),
  ...roleplay.state(),
})
export const actions = { ...a, ...premissas.actions, ...roleplay.actions }
export const mutations = { ...m, ...premissas.mutations, ...roleplay.mutations }
export const getters = { ...g, ...premissas.getters, ...roleplay.getters }
